export const PMF_SOURCE = 'PMF';
export const PMF_BASECASE_PREFIX = 'PLT26_';
export const PMF_MAX_YEAR = 2035;

